<template>
  <div class="ivu-modal-wrap" style="z-index: 1008;background:rgba(55,55,55,.6);display:flex;justify-content:center;align-items:center">
    <div style="width:58vw;height:50vh;background:#fff;padding:3vh;border:1px solid #666">
        <div style="width:100%;height:100%; position: relative;">
          <p style="text-align:center;font-size:16px">合理用药</p>
              <div v-for="(item,index) in errorList" :key="index" style="width:100%;display:inline-block">
                <div style="display:flex;justify-content:space-between">
                  <div>
                    <span>问题药品：{{item.name}}</span>
                  </div>
                  <div>
                    <span>{{item.title}}</span>？？<span>一般警示</span>
                  </div>
                </div>
                <div>
                  <span>警示信息：{{item.warningInfo}}</span>
                </div>
                <div>
                  <span>参考资料：{{item.linkInfo}}</span>
                </div>
              </div>
              <div  v-if="index<errorList.length-1" style="width:100%;height:1px; background:#3333"></div>
              <div  style="width:100%;position: absolute;left: 0;bottom:0;display: flex;justify-content: center;align-items: center;">
                <div @click="closeModal" style="padding:5px 10px;border-radius:4px;font-size:14px;color:#fff;background:#4AA5FE;">
                  返回调方
                </div>
              </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props:['errorList'],
  methods:{
    closeModal(){
      this.$emit('closeModal');
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Error/eror.vue